export default "__VITE_ASSET__CzMxERKC__"